module.exports = __webpack_public_path__ + "img/smyyj.287d3104.png";